<div class="content-main">    
    <div class="content">
        
        <mat-accordion multi>
            <mat-expansion-panel *ngFor="let item of attribs|filterChildLength:'mpUda'">
                <mat-expansion-panel-header>
                    {{item.udaGroupName}}
                </mat-expansion-panel-header>
                <mat-grid-list cols="4" rowHeight="150px">
                    <mat-grid-tile
                        *ngFor="let data of item.mpUda">
                        <div class="data-card">
                            <ng-container  [ngTemplateOutlet]="main" [ngTemplateOutletContext]="{$implicit:data}" ></ng-container>            
                        </div>
                    </mat-grid-tile>
                </mat-grid-list>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
    <actions-buttons [buttonList]="buttonList"></actions-buttons>
</div>

<ng-template #main let-item let-type="type" >
    <mat-card  appearance="outlined"  [ngClass]="{'cardnon':!isRequired(item), 'cardred':isRequired(item)}" >
        <mat-card-header>
            <mat-icon class="close" (click)="deleteItem(item)" *ngIf="!isRequired(item)">close</mat-icon>
            <mat-card-title [matTooltip]="item.udaName">
            {{item.udaName}}
            <mat-icon class="warn" matTooltip="Esse atributo é de variação" *ngIf="isVariant(item)">warning</mat-icon>
            </mat-card-title>
            <mat-card-subtitle [matTooltip]="item.hint">{{item.attribute_id}}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
        <mat-form-field appearance="outline"  *ngIf="item.udaValues.length ==0" class="full" >
            <mat-label>{{item.udaName}}</mat-label>
            <input matInput type="text"  [(ngModel)]="item.datavalue" [required]="isRequired(item)" [CustomValidatorDirective]="attribValidator">
            <button   matSuffix mat-icon-button aria-label="Clear" (click)="openDataOption(item)" matTooltip="Buscar Informação">
                <mat-icon>reply</mat-icon>
            </button>
            <button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="value=''">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
        
        <mat-form-field appearance="outline" *ngIf="item.udaValues.length > 0" class="full">
            <mat-label>{{item.udaName}}</mat-label>
            <mat-select #select  [(value)]="item.datavalue" [required]="isRequired(item)"  (blur)="onBlur(item)" [CustomValidatorDirective]="attribValidator">
                <mat-option></mat-option>
                <mat-option [value]="option.udaValueId" *ngFor="let option of item.udaValues">{{ option.udaValue }}</mat-option>
            </mat-select>
        </mat-form-field>


        
        </mat-card-content>
    </mat-card>
</ng-template>